import { isEqual, union } from 'lodash'

import { SYSTEM_DEFAULT_FILTER_STATE } from '../../modules/Filters/Filters.constants'
import { IFilters } from '../../shared/interfaces/filters/IFilters'
import { IUser } from '../../shared/interfaces/settings/Settings'
import { hasPermission } from '../authorizations/permissions.selectors'

import { defaultFiltersForUser } from './defaultFiltersForUser'

export const getActiveFiltersForUser = (user: IUser, filters: IFilters): IFilters => {
  // If the current filters are the empty default state (SYSTEM_DEFAULT_FILTER_STATE), we use the default filters for the user.
  // If they're not empty (from localStorage), we use those. This allows for restoring of the filters after authentication.
  if (isEqual(filters, SYSTEM_DEFAULT_FILTER_STATE)) {
    return defaultFiltersForUser(user)
  }

  // A persisted berthUuids selection predates any berth added to the user's authorization
  // afterwards, which would otherwise hide that berth (and its portcalls) forever. Union in
  // newly authorized berths instead of trusting the stale snapshot as-is.
  return {
    ...filters,
    berthUuids: hasPermission('filter:berths', user.permissions) ? union(filters.berthUuids, user.berthUuids) : filters.berthUuids,
  }
}
